/** Schedule durable automatic selection; specific awards are always on demand. */
import { Info } from 'lucide-react'

import type { ConnectorSchedule } from '@/subsystems/vault/connectors/types'
import { ConnectorScheduleSelect } from '@/subsystems/vault/connectors/components/ConnectorScheduleSelect'

export function KualiResearchSyncOptions({
  schedule,
  onScheduleChange,
  specificOnly,
  disabled = false,
}: {
  schedule: ConnectorSchedule
  onScheduleChange: (value: ConnectorSchedule) => void
  specificOnly: boolean
  disabled?: boolean
}) {
  return (
    <section className="space-y-2">
      <h3 className="text-[12px] font-semibold text-slate-700">Sync schedule</h3>
      {specificOnly ? (
        <>
          <div className="flex items-center gap-2.5 opacity-55">
            <span className="text-[12.5px] text-slate-700">Run automatically</span>
            <span className="inline-flex h-8 items-center rounded-[8px] border border-slate-200 bg-slate-100 px-3 text-[12.5px] font-semibold text-slate-400">
              Off
            </span>
          </div>
          <p className="flex items-start gap-1.5 rounded-[8px] border border-[#eef1f5] bg-slate-50 px-2.5 py-2 text-[12px] leading-4 text-slate-500">
            <Info className="mt-px h-3.5 w-3.5 shrink-0" aria-hidden="true" />
            <span>
              Specific awards never sync on a schedule — they transfer only when you use{' '}
              <strong className="font-semibold text-slate-700">Manage awards</strong>.
            </span>
          </p>
        </>
      ) : (
        <div className="flex items-center gap-2.5">
          <span className="text-[12.5px] text-slate-700">Run automatically</span>
          <ConnectorScheduleSelect
            value={schedule}
            onChange={onScheduleChange}
            disabled={disabled}
            ariaLabel="Kuali Research connector schedule"
            className="h-8 w-[170px] rounded-[8px] text-[12.5px] font-semibold"
          />
        </div>
      )}
    </section>
  )
}
